<template lang="pug">
.utm-table-container
  b-table.table.mt-3(
    :items='items'
    :fields='fields'
    :sort-by='"utmCampaign"'
    hover
    striped
    small
    responsive
  )
</template>

<script>
import { authBackend } from '../api'

const fields = [
  { key: 'utmCampaign',
    label: 'Campaign',
    sortable: true
  },
  { key: 'utmSource',
    label: 'Source',
    sortable: true
  },
  { key: 'utmContent',
    label: 'Content',
    sortable: true
  },
  { key: 'supporterCount',
    label: 'Annetajaid kokku',
    sortable: true
  },
  { key: 'recurringCount',
    label: 'Püsiannetajaid',
    sortable: true
  },
  { key: 'oneOffCount',
    label: 'Ühekordseid annetajaid',
    sortable: true
  },
  { key: 'recurringTotal',
    label: 'Püsiannetuste summa',
    sortable: true
  },
  { key: 'oneOffTotal',
    label: 'Ühekordsete summa',
    sortable: true
  }
]

export default {
  data() {
    return {
      fields,
      items: []
    }
  },

  async created() {
    this.items = (await authBackend().get('/api/dashboard/utm')).data
  }
}
</script>

<style lang="scss">
.utm-table-container {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .table {
    max-width: 1000px;
  }
}
</style>
